// extracted by mini-css-extract-plugin
export var container = "Treaty-module--container--87ec5";
export var description = "Treaty-module--description--13767";
export var longTitle = "Treaty-module--long-title--0b84e";
export var name = "Treaty-module--name--95804";
export var subtitle = "Treaty-module--subtitle--80d4f";
export var title = "Treaty-module--title--f3bad";